export enum HubMethods {
    OnItem = 'OnItem',
}
